import * as React from "react";

export type CollectionItemTagsProps = {
    title: string;
    description: string;
    tags: string[];
    collectionSearchPageUrl: string;
};

export const CollectionItemTags = ({ title, description, tags, collectionSearchPageUrl }: CollectionItemTagsProps) => {
    return (
        <div className="CollectionItemTags">
            <h2>{title}</h2>
            <p className="CollectionItemTags__description">{description}</p>
            <ul className="CollectionItemTags__tags">
                {tags.map((tag) => (
                    <li key={tag}>
                        <a className="CollectionItemTags__tag" href={collectionSearchPageUrl + "?query=&motif=" + tag}>
                            {tag}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};
